// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import {
  Box,
  CircularProgress,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";

export const DataLoader = (props: { message: string | null }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          minHeight: "60vh",
        }}
      >
        <img src="/data-loading.svg" alt="Loading..." height={200} />
        <div style={{ width: "25%", marginTop: 50, marginBottom: 10 }}>
          <LinearProgress color="secondary" />
        </div>
        <Typography variant="body1" style={{ color: "gray" }}>
          {props.message}
        </Typography>
      </Box>
    </>
  );
};
